export const GET_ALL_PATIENT_QUESTIONNAIRES = 'GET_ALL_PATIENT_QUESTIONNAIRES';
export const GET_LOADING_QUESTIONNAIRES = 'GET_LOADING_QUESTIONNAIRES';
export const GET_ALL_QUESTIONNAIRES = 'GET_ALL_QUESTIONNAIRES';
export const GET_LOADING_ALL_QUESTIONNAIRES = 'GET_LOADING_ALL_QUESTIONNAIRES';
export const GET_PAIN_DETECT_PICS = 'GET_PAIN_DETECT_PICS';
export const LOADING_PAIN_DETECT_PICS = 'LOADING_PAIN_DETECT_PICS';
export const EQ_LEGEND_VALUE = 'EQ_LEGEND_VALUE';
export const GET_AVAILABLE_PATIENT_QUESTIONNAIRES = 'GET_AVAILABLE_PATIENT_QUESTIONNAIRES';
export const LOADING_AVAILABLE_PATIENT_QUESTIONNAIRES = 'LOADING_AVAILABLE_PATIENT_QUESTIONNAIRES';
